// Generated by purs version 0.15.0
import * as Data_Array_NonEmpty_Serialized from "../Data.Array.NonEmpty.Serialized/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Map_Ordered from "../Data.Map.Ordered/index.js";
import * as Data_Map_Serialized from "../Data.Map.Serialized/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Set_Serialized from "../Data.Set.Serialized/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Tuple_T2 from "../Data.Tuple.T2/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_I18n_Types from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic_Menu_V2_Types_Color from "../Restaumatic.Menu.V2.Types.Color/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Restaumatic_Menu_V2_Types_MenuConsumer from "../Restaumatic.Menu.V2.Types.MenuConsumer/index.js";
import * as Restaumatic_Menu_V2_Types_Photo from "../Restaumatic.Menu.V2.Types.Photo/index.js";
import * as Restaumatic_Menu_V2_Types_UIElement from "../Restaumatic.Menu.V2.Types.UIElement/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var SingleProduct = /* #__PURE__ */ (function () {
    function SingleProduct(value0) {
        this.value0 = value0;
    };
    SingleProduct.create = function (value0) {
        return new SingleProduct(value0);
    };
    return SingleProduct;
})();
var ProductCombo = /* #__PURE__ */ (function () {
    function ProductCombo(value0) {
        this.value0 = value0;
    };
    ProductCombo.create = function (value0) {
        return new ProductCombo(value0);
    };
    return ProductCombo;
})();
var ProductCreator = /* #__PURE__ */ (function () {
    function ProductCreator(value0) {
        this.value0 = value0;
    };
    ProductCreator.create = function (value0) {
        return new ProductCreator(value0);
    };
    return ProductCreator;
})();
var UIElement = /* #__PURE__ */ (function () {
    function UIElement(value0) {
        this.value0 = value0;
    };
    UIElement.create = function (value0) {
        return new UIElement(value0);
    };
    return UIElement;
})();
var Products = /* #__PURE__ */ (function () {
    function Products(value0) {
        this.value0 = value0;
    };
    Products.create = function (value0) {
        return new Products(value0);
    };
    return Products;
})();
var MostPopular = /* #__PURE__ */ (function () {
    function MostPopular(value0) {
        this.value0 = value0;
    };
    MostPopular.create = function (value0) {
        return new MostPopular(value0);
    };
    return MostPopular;
})();
var GenericFormula = /* #__PURE__ */ (function () {
    function GenericFormula() {

    };
    GenericFormula.value = new GenericFormula();
    return GenericFormula;
})();
var ArbitraryHtml = /* #__PURE__ */ (function () {
    function ArbitraryHtml(value0) {
        this.value0 = value0;
    };
    ArbitraryHtml.create = function (value0) {
        return new ArbitraryHtml(value0);
    };
    return ArbitraryHtml;
})();
var MenuSection = function (x) {
    return x;
};
var newtypeMenuSection_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldMenuSection = function (dictHasField) {
    return dictHasField;
};
var eqMenuSectionItem = {
    eq: function (x) {
        return function (y) {
            if (x instanceof SingleProduct && y instanceof SingleProduct) {
                return Data_Eq.eq(Data_Map_Serialized.eqMap(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))(x.value0.customParameterValues)(y.value0.customParameterValues) && Data_Eq.eq(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(x.value0.itemProduct)(y.value0.itemProduct);
            };
            if (x instanceof ProductCombo && y instanceof ProductCombo) {
                return Data_Eq.eq(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(x.value0.combo)(y.value0.combo);
            };
            if (x instanceof ProductCreator && y instanceof ProductCreator) {
                return Data_Eq.eq(Restaumatic_I18n_Types.eqTranslated(Data_Eq.eqString))(x.value0.creatorDescription)(y.value0.creatorDescription) && Data_Eq.eq(Restaumatic_I18n_Types.eqTranslated(Data_Eq.eqString))(x.value0.creatorName)(y.value0.creatorName) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Photo.eqPhoto))(x.value0.creatorPhoto)(y.value0.creatorPhoto) && Data_Eq.eq(Data_Array_NonEmpty_Serialized.eqNonEmptyArray(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))(x.value0.creatorProducts)(y.value0.creatorProducts);
            };
            if (x instanceof UIElement && y instanceof UIElement) {
                return Data_Eq.eq(Restaumatic_Menu_V2_Types_UIElement.eqUIElement)(x.value0.uiElement)(y.value0.uiElement);
            };
            return false;
        };
    }
};
var eqSectionContent = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Products && y instanceof Products) {
                return Data_Eq.eq(Data_Map_Ordered.eqOMap(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(eqMenuSectionItem))(x.value0.items)(y.value0.items);
            };
            if (x instanceof MostPopular && y instanceof MostPopular) {
                return x.value0.howMany === y.value0.howMany;
            };
            if (x instanceof GenericFormula && y instanceof GenericFormula) {
                return true;
            };
            if (x instanceof ArbitraryHtml && y instanceof ArbitraryHtml) {
                return x.value0 === y.value0;
            };
            return false;
        };
    }
};
var eqMenuSection = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Color.eqColor))(x.color)(y.color) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))(x.columnParameter)(y.columnParameter) && Data_Eq.eq(eqSectionContent)(x.content)(y.content) && Data_Eq.eq(Data_Map_Serialized.eqMap(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))(x.customParameterValues)(y.customParameterValues) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))(x.defaultCategory)(y.defaultCategory) && Data_Eq.eq(Restaumatic_I18n_Types.eqTranslated(Data_Eq.eqString))(x.description)(y.description) && Data_Eq.eq(Data_Eq.eqArray(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))(x.dropdownParameters)(y.dropdownParameters) && Data_Eq.eq(Restaumatic_I18n_Types.eqTranslated(Data_Eq.eqString))(x.name)(y.name) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Photo.eqPhoto))(x.photo)(y.photo) && Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))(x.visibilitySchedule)(y.visibilitySchedule) && x.visible === y.visible && Data_Eq.eq(Data_Set_Serialized.eqSet(Restaumatic_Menu_V2_Types_MenuConsumer.eqMenuConsumer))(x.visibleIn)(y.visibleIn);
        };
    }
};
var genericSectionContent = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new Products(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new MostPopular(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return GenericFormula.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return new ArbitraryHtml(x.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.MenuSection (line 30, column 1 - line 30, column 83): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Products) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof MostPopular) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof GenericFormula) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof ArbitraryHtml) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)));
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.MenuSection (line 30, column 1 - line 30, column 83): " + [ x.constructor.name ]);
    }
};
var genericMenuSectionItem = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new SingleProduct(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return new ProductCombo(x.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return new ProductCreator(x.value0.value0.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inr)) {
            return new UIElement(x.value0.value0.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.MenuSection (line 54, column 1 - line 54, column 85): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof SingleProduct) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof ProductCombo) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0));
        };
        if (x instanceof ProductCreator) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(x.value0)));
        };
        if (x instanceof UIElement) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(x.value0)));
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.V2.Types.MenuSection (line 54, column 1 - line 54, column 85): " + [ x.constructor.name ]);
    }
};
var showMenuSectionItem = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericMenuSectionItem)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "customParameterValues";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "itemProduct";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId))(/* #__PURE__ */ Data_Map_Serialized.showMap(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))))({
        reflectSymbol: function () {
            return "SingleProduct";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "combo";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId))))({
        reflectSymbol: function () {
            return "ProductCombo";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "creatorDescription";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "creatorName";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "creatorPhoto";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "creatorProducts";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Array_NonEmpty_Serialized.showNonEmptyArray(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Photo.showPhoto)))(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString)))(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString)))))({
        reflectSymbol: function () {
            return "ProductCreator";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "uiElement";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Menu_V2_Types_UIElement.showUIElement))))({
        reflectSymbol: function () {
            return "UIElement";
        }
    })))))
};
var showSectionContent = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericSectionContent)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "items";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Map_Ordered.showOMap(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)(showMenuSectionItem)))))({
        reflectSymbol: function () {
            return "Products";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "howMany";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showInt))))({
        reflectSymbol: function () {
            return "MostPopular";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "GenericFormula";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Data_Show.showString))({
        reflectSymbol: function () {
            return "ArbitraryHtml";
        }
    })))))
};
var unscrambleDecodeMenuSectionItem = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericMenuSectionItem)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "SingleProduct";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "customParameterValues";
        }
    })(/* #__PURE__ */ Data_Map_Serialized.udecodeMap(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.ufromJSONKey)(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "itemProduct";
        }
    })(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId)(Unscramble.decodeRecordNil)))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "ProductCombo";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "combo";
        }
    })(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId)(Unscramble.decodeRecordNil))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "ProductCreator";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "creatorDescription";
        }
    })(/* #__PURE__ */ Restaumatic_I18n_Types.udecodeTranslated(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "creatorName";
        }
    })(/* #__PURE__ */ Restaumatic_I18n_Types.udecodeTranslated(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "creatorPhoto";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Photo.unscrambleDecodePhoto))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "creatorProducts";
        }
    })(/* #__PURE__ */ Data_Array_NonEmpty_Serialized.udecodeNonEmptyArray(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId))(Unscramble.decodeRecordNil)))))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "UIElement";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "uiElement";
        }
    })(Restaumatic_Menu_V2_Types_UIElement.unscrambleDecodeUIElement)(Unscramble.decodeRecordNil))))))))(Unscramble_Generic.defaultOptions)
};
var unscrambleDecodeSectionContent = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericSectionContent)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "Products";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Data_Map_Ordered.udecodeMap(unscrambleDecodeMenuSectionItem)(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId))(Unscramble.decodeRecordNil))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "MostPopular";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "howMany";
        }
    })(Unscramble.decodeInt1)(Unscramble.decodeRecordNil))))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct1(Unscramble_Generic.genericDecodeArgsNoArgume)({
        reflectSymbol: function () {
            return "GenericFormula";
        }
    }))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct({
        reflectSymbol: function () {
            return "ArbitraryHtml";
        }
    })(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Unscramble.decodeString1)))))))(Unscramble_Generic.defaultOptions)
};
var genericMenuSection = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showMenuSection = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericMenuSection)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "color";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "columnParameter";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "content";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "customParameterValues";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "defaultCategory";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "dropdownParameters";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "visibilitySchedule";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "visible";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "visibleIn";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Set_Serialized.showSet(Restaumatic_Menu_V2_Types_MenuConsumer.showMenuConsumer)))(Data_Show.showBoolean))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Photo.showPhoto)))(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString)))(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))(/* #__PURE__ */ Restaumatic_I18n_Types.showTranslated(Data_Show.showString)))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))(/* #__PURE__ */ Data_Map_Serialized.showMap(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))(showSectionContent))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_Color.showColor)))))({
        reflectSymbol: function () {
            return "MenuSection";
        }
    }))
};
var unscrambleDecodeMenuSection = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericMenuSection)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "color";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Color.unscrambleDecodeColor))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "columnParameter";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "content";
        }
    })(unscrambleDecodeSectionContent)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "customParameterValues";
        }
    })(/* #__PURE__ */ Data_Map_Serialized.udecodeMap(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.ufromJSONKey)(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "defaultCategory";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Restaumatic_I18n_Types.udecodeTranslated(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "dropdownParameters";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Restaumatic_I18n_Types.udecodeTranslated(Unscramble.decodeString1))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Photo.unscrambleDecodePhoto))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "visibilitySchedule";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "visible";
        }
    })(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "visibleIn";
        }
    })(/* #__PURE__ */ Data_Set_Serialized.udecodeSet(Restaumatic_Menu_V2_Types_MenuConsumer.ordMenuConsumer)(Restaumatic_Menu_V2_Types_MenuConsumer.unscrambleDecodeMenuConsumer))(Unscramble.decodeRecordNil))))))))))))))))(Unscramble_Generic.defaultOptions)
};
var encodeMenuSectionItem = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericMenuSectionItem)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "SingleProduct";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "itemProduct";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId)))({
        reflectSymbol: function () {
            return "customParameterValues";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Map_Serialized.encodeMap(Restaumatic_Menu_V2_Types_Ids_EntityId.asJSONKeyEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId)))))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ProductCombo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "combo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ProductCreator";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "creatorProducts";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Array_NonEmpty_Serialized.encodeNonEmptyArray(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId))))({
        reflectSymbol: function () {
            return "creatorPhoto";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Photo.encodePhoto))))({
        reflectSymbol: function () {
            return "creatorName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.encodeTranslated(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "creatorDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.encodeTranslated(Foreign_Generic_Class.stringEncode)))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "UIElement";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "uiElement";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_UIElement.encodeUIElement)))))))))
};
var encodeSectionContent = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericSectionContent)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Products";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Map_Ordered.encodeMap(/* #__PURE__ */ Data_Tuple_T2.encodeT2(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId)))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeMenuSectionItem))))))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "MostPopular";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "howMany";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.intEncode))))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "GenericFormula";
        }
    })(Foreign_Generic_Class.genericEncodeArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "ArbitraryHtml";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))))))
};
var encodeMenuSection = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericMenuSection)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "MenuSection";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "visibleIn";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Set_Serialized.encodeSet(Restaumatic_Menu_V2_Types_MenuConsumer.encodeMenuConsumer))))({
        reflectSymbol: function () {
            return "visible";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode)))({
        reflectSymbol: function () {
            return "visibilitySchedule";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId))))({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Photo.encodePhoto))))({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.encodeTranslated(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "dropdownParameters";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId))))({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.encodeTranslated(Foreign_Generic_Class.stringEncode))))({
        reflectSymbol: function () {
            return "defaultCategory";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId))))({
        reflectSymbol: function () {
            return "customParameterValues";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Data_Map_Serialized.encodeMap(Restaumatic_Menu_V2_Types_Ids_EntityId.asJSONKeyEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId))))))({
        reflectSymbol: function () {
            return "content";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeSectionContent)))({
        reflectSymbol: function () {
            return "columnParameter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId))))({
        reflectSymbol: function () {
            return "color";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_Color.encodeColor)))))))
};
var decodeMenuSectionItem = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericMenuSectionItem)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "SingleProduct";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "itemProduct";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId))())({
        reflectSymbol: function () {
            return "customParameterValues";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Map_Serialized.decodeMap(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.asJSONKeyEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ProductCombo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "combo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ProductCreator";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "creatorProducts";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Array_NonEmpty_Serialized.decodeNonEmptyArray(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))())({
        reflectSymbol: function () {
            return "creatorPhoto";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Photo.decodePhoto)))())({
        reflectSymbol: function () {
            return "creatorName";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.decodeTranslated(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "creatorDescription";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.decodeTranslated(Foreign_Generic_Class.stringDecode)))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "UIElement";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "uiElement";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_UIElement.decodeUIElement))())))(Foreign_Generic_Class.genericCountArgsArgument)))))
};
var decodeSectionContent = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericSectionContent)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Products";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "items";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Map_Ordered.decodeMap(/* #__PURE__ */ Data_Tuple_T2.decodeT2(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeMenuSectionItem))))(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "MostPopular";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "howMany";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.intDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "GenericFormula";
        }
    })(Foreign_Generic_Class.genericDecodeArgsNoArguments)(Foreign_Generic_Class.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "ArbitraryHtml";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode)))(Foreign_Generic_Class.genericCountArgsArgument)))))
};
var decodeMenuSection = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericMenuSection)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "MenuSection";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "visibleIn";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Set_Serialized.decodeSet(Restaumatic_Menu_V2_Types_MenuConsumer.ordMenuConsumer)(Restaumatic_Menu_V2_Types_MenuConsumer.decodeMenuConsumer)))())({
        reflectSymbol: function () {
            return "visible";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())({
        reflectSymbol: function () {
            return "visibilitySchedule";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))())({
        reflectSymbol: function () {
            return "photo";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Photo.decodePhoto)))())({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.decodeTranslated(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "dropdownParameters";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))())({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Restaumatic_I18n_Types.decodeTranslated(Foreign_Generic_Class.stringDecode)))())({
        reflectSymbol: function () {
            return "defaultCategory";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))())({
        reflectSymbol: function () {
            return "customParameterValues";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Data_Map_Serialized.decodeMap(Restaumatic_Menu_V2_Types_Ids_EntityId.ordEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.asJSONKeyEntityId)(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))))())({
        reflectSymbol: function () {
            return "content";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeSectionContent))())({
        reflectSymbol: function () {
            return "columnParameter";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))())({
        reflectSymbol: function () {
            return "color";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_Color.decodeColor)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    Products,
    MostPopular,
    GenericFormula,
    ArbitraryHtml,
    SingleProduct,
    ProductCombo,
    ProductCreator,
    UIElement,
    MenuSection,
    genericSectionContent,
    eqSectionContent,
    showSectionContent,
    encodeSectionContent,
    decodeSectionContent,
    unscrambleDecodeSectionContent,
    genericMenuSectionItem,
    eqMenuSectionItem,
    showMenuSectionItem,
    encodeMenuSectionItem,
    decodeMenuSectionItem,
    unscrambleDecodeMenuSectionItem,
    genericMenuSection,
    eqMenuSection,
    showMenuSection,
    encodeMenuSection,
    decodeMenuSection,
    unscrambleDecodeMenuSection,
    hasFieldMenuSection,
    newtypeMenuSection_
};
//# sourceMappingURL=index.js.map
